<div class="grid-container">
  <div class="grid">
    <div class="grid-item" *ngFor="let item of getProcessedItems(); trackBy: trackByFn">
      <ng-container *ngIf="item !== newTemplate; else newTemplateContainer">
        <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: item }"></ng-container>
      </ng-container>
    </div>

  </div>
</div>

<ng-template #newTemplateContainer>
  <ng-container *ngTemplateOutlet="newTemplate"></ng-container>
</ng-template>